import {useRef, useEffect} from "react";
import {Text} from "@mantine/core";
import {Trans, useTranslation} from "react-i18next";
import type {Status} from "../../types";
import {getStatusDisplayName} from "../statusNames";
import {ChecklistModal} from "../ChecklistModal";
import classes from "../modalStyles.module.css";

type ConfirmCheckAllModalProps = {
    opened: boolean;
    onClose: () => void;
    onConfirm: () => void;
    status: Status;
};

export const ConfirmCheckAllModal = ({
    opened,
    onClose,
    onConfirm,
    status,
}: ConfirmCheckAllModalProps) => {
    const {t} = useTranslation();
    const cancelRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (opened) {
            setTimeout(() => cancelRef.current?.focus(), 50);
        }
    }, [opened]);

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <ChecklistModal
            opened={opened}
            onClose={onClose}
            title={t("Label.ConfirmAction")}
            primary={{label: t("Word.Confirm"), onClick: handleConfirm}}
            secondary={{
                label: t("common.cancel"),
                onClick: onClose,
                buttonRef: cancelRef,
            }}
        >
            <Text className={classes.modalText}>
                <Trans
                    i18nKey="Warning.AboutToMarkAllChecklistItems"
                    values={{status: getStatusDisplayName(status)}}
                    components={{strong: <strong />}}
                />
            </Text>
        </ChecklistModal>
    );
};
